import type { FirebaseStorage } from 'firebase/storage';

import { getFirebaseApp } from '@/services/firebase/config';

let storageInstance: FirebaseStorage | null = null;

export async function getStorage(): Promise<FirebaseStorage> {
  if (storageInstance) return storageInstance;
  const app = await getFirebaseApp();
  const { getStorage: getFirebaseStorage } = await import('firebase/storage');
  storageInstance = getFirebaseStorage(app);
  return storageInstance;
}

function photoPath(userId: string, photoId: string): string {
  return `users/${userId}/photos/${photoId}.bin`;
}

export async function uploadEncryptedPhoto(
  userId: string,
  photoId: string,
  ciphertext: Uint8Array,
): Promise<void> {
  const storage = await getStorage();
  const { ref, uploadBytes } = await import('firebase/storage');
  const r = ref(storage, photoPath(userId, photoId));
  await uploadBytes(r, ciphertext, { contentType: 'application/octet-stream' });
}

export async function downloadEncryptedPhoto(
  userId: string,
  photoId: string,
): Promise<Uint8Array | null> {
  const storage = await getStorage();
  const { ref, getBytes } = await import('firebase/storage');
  const r = ref(storage, photoPath(userId, photoId));
  try {
    const buffer = await getBytes(r);
    return new Uint8Array(buffer);
  } catch (err) {
    if (
      typeof err === 'object' &&
      err !== null &&
      (err as { code?: string }).code === 'storage/object-not-found'
    ) {
      return null;
    }
    throw err;
  }
}

export async function deleteRemotePhoto(userId: string, photoId: string): Promise<void> {
  const storage = await getStorage();
  const { ref, deleteObject } = await import('firebase/storage');
  const r = ref(storage, photoPath(userId, photoId));
  try {
    await deleteObject(r);
  } catch (err) {
    if (
      typeof err === 'object' &&
      err !== null &&
      (err as { code?: string }).code === 'storage/object-not-found'
    ) {
      return;
    }
    throw err;
  }
}
